// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from 'react';
import {
    Select, MenuItem, ListItemText,
    FormControl, SelectChangeEvent, Checkbox
} from '@mui/material';

const regionOptions = [
    "AFRICA", "ANZ", "ASIA", "Benelux + France",
    "LATAM", "ME", "NA - CENTRAL", "NA - EAST", "NA - SOUTH", "NA - WEST",
    "ROE", "RoA", "SAARC", "UK", "UK + Ireland"
];

interface RegionFilterSelectProps {
    selectedRegions: string[];
    onRegionChange: (newRegions: string[]) => void;
}

export const RegionFilterSelect: React.FC<RegionFilterSelectProps> = ({ selectedRegions, onRegionChange }) => {

    const handleChange = (event: SelectChangeEvent<string[]>) => {
        const value = event.target.value;
        onRegionChange(typeof value === 'string' ? value.split(',') : value);
    };

    return (
        <FormControl sx={{ m: 1, width: 200 }} size="small">
            <Select
                multiple
                value={selectedRegions}
                onChange={handleChange}
                displayEmpty
                renderValue={(selected) => {
                    if (!selected || (selected as string[]).length === 0) return "All Regions";
                    if ((selected as string[]).length === 1) return (selected as string[])[0];
                    return `${(selected as string[]).length} Regions`;
                }}
            >
                {regionOptions.map((region) => (
                    <MenuItem key={region} value={region}>
                        <Checkbox checked={selectedRegions.indexOf(region) > -1} />
                        <ListItemText primary={region} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
